import React, { useMemo } from 'react';
import { Typography } from '@mui/material';
import DeviceIcon from '#component/icon/device-icon';
import { Tooltip, Label, SvgIcon, StyledDivider } from './styles';

/**
 * Renders device info, metrics, events etc.
 * Fetches device info data.
 */

const DevicesTooltip = props => {
  const { properties, meta } = props;

  const types = useMemo(() =>
    meta.device.reduce((a, c) => {
      if (properties[c.name]) {
        a.push({
          type: c.name,
          label: c.label,
          count: properties[c.name],
          icon: c.icon
        });
      }
      return a;
    }, []), [meta, properties]);

  return (
    <Tooltip>
      {types.map(t =>
        <Label key={t.type}>
          <SvgIcon>
            <DeviceIcon icon={t.icon} />
          </SvgIcon>
          <Typography component="p" color="textSecondary">{` ${t.label}: ${t.count}`}</Typography>
        </Label>)}
      <StyledDivider />
      <Label>
        <Typography component="p" color="textSecondary">
          {`Active: ${properties.occupier}/${properties.point_count}`}
        </Typography>
      </Label>
    </Tooltip>
  );
};

export default DevicesTooltip;
